import MassiveTimelineView from './MassiveTimelineView';
import './MassiveTimelineView.css';
export default MassiveTimelineView;
